module.exports = "<app-header (featureSelected)=\"onNavigate($event)\"></app-header>\r\n<div class=\"container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <app-recipe-book *ngIf=\"loadedFeature === 'recipes'\"></app-recipe-book>\r\n            <app-shopping-list *ngIf=\"loadedFeature === 'shopping-list'\"></app-shopping-list>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/gitHub/cookbook/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main